import { FNADetails } from '../../common/types/analyses';
import { JSX } from 'react';
import PageHeaderSummary from '../../common/components/pageHeaderSummary';

interface FnaPageHeaderSummaryProps {
  /**
   * FNA details
   */
  fna: FNADetails;
  /**
   * Page header title
   * @default 'Financial needs analysis'
   */
  title?: string;
}

/**
 * Summary page header for the FNA pages
 */
const FnaPageHeaderSummary = ({
  fna,
  title = 'Financial needs analysis',
}: FnaPageHeaderSummaryProps): JSX.Element => {
  const fnaRoleplayers =
    fna.roleplayers.map(({ roleplayerName }) => roleplayerName).join(', ') || '-';

  const summaryItems = [
    {
      title: 'For',
      value: fnaRoleplayers,
    },
    {
      title: 'Description',
      value: fna.description,
    },
    {
      title: 'Reference number',
      value: fna.id,
    },
    {
      title: 'Status',
      value: fna.stateNote,
    },
  ];

  return <PageHeaderSummary title={title} items={summaryItems} />;
};

export default FnaPageHeaderSummary;
